
import { computed, defineComponent, onMounted, ref } from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";

import {getcountries, getcities}  from "@/api/common";
import { confirm_register, save_register}  from "@/api/register";
import { getCurrentUser } from "@/utils/index"


import ConfirmRegisterBiboEndorser from "@/views/auth/ConfirmRegisterBiboEndorser.vue";

interface Step1 { 
  insured_firstName: string;
  insured_middleName: string;
  insured_lastName: string;
  insured_birthday: string;
  username: string;
  password: string;
  cpassword: string;
  sponsorid: string;
  uplineid: string;
  position: string;
}

interface Step2 { 
  
 

}

interface Step3 {
  userid: string;
  securitypin: string;
  verifyingdata: boolean; 
  country_text: string;
  province_text: string;
  responsedata: object;
}

interface Step4 {
}

interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "create-account-modal",
  data() {
    return {   
        address_country: "",
        confirm_data: {},
         user : {}

    }
  },
  components: {
    Field,
    ErrorMessage,
    ConfirmRegisterBiboEndorser
  },
  props: { 
        slotdata: Object
  },
  setup(props, context) {
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAccountRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);

    const countries = ref([]) as any; 
    const cities = ref([]) as any; 


    const isDisabledUPID = props.slotdata !== undefined && props.slotdata.upid !== undefined;
    const isBibo = String(localStorage.getItem("pt")) == "bibo";
    
    const httpGetCountries =  async () => { 
      countries.value = [];
        const response = await getcountries(); 
        if(response.data !== undefined && response.data.countries !== undefined) {
          countries.value = response.data.countries; 
        }
       
    }; 


    const getCities = async(country_id) => {  
        cities.value = [];
        const response = await getcities(country_id); 
        if(response.data !== undefined && response.data.cities !== undefined) {
            cities.value = response.data.cities; 
        }
    };


    const formData = ref<KTCreateApp>({   
      
      verifyingdata: false,
      country_text: "",
      province_text: "",
      responsedata: {},
      insured_firstName: "",
      insured_middleName: "",
      insured_lastName: "",
      insured_birthday: "",
      username: "",
      password: "",
      cpassword: "",
      sponsorid:  (props.slotdata !== undefined && props.slotdata.spid !== undefined) ? props.slotdata.spid : "",
      uplineid: (props.slotdata !== undefined && props.slotdata.upid !== undefined) ? props.slotdata.upid : "",
      position: (props.slotdata !== undefined && props.slotdata.position !== undefined) ? props.slotdata.position : "",
      
      userid: "",
      securitypin: ""
    });
 
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAccountRef.value as HTMLElement
      );   
      console.log("mounted registermodalbibo");

      if(props.slotdata !== undefined && props.slotdata.upid !== undefined) {
          formData.value.uplineid = props.slotdata.upid;
          formData.value.sponsorid = props.slotdata.spid;
          formData.value.position = props.slotdata.position;
      }
      httpGetCountries();
    });

    const createAppSchema = [
      Yup.object({}),  
      
      Yup.object({ 
        username: Yup.string()
          .required()
          .label("Your Account Username"),
        password: Yup.string()
          .required()
          .label("Your Account Password"),
        cpassword: Yup.string()
          .required()
          .label("Your Account Password Confirmation"), 
        sponsorid: Yup.string()
          .required()
          .max(20)
          .label("Sponsor User ID"),
        uplineid: Yup.string()
          .required()
          .max(20)
          .label("Upline User ID"),
        position: Yup.string()
          .required()
          .label("Position")
      }), 

     

      Yup.object({ 
        userid: Yup.string()
          .required()
          .max(20)
          .label("Activation User ID"),
        securitypin: Yup.string()
          .required()
          .max(20)
          .label("Activation PIN") 


      }) 
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit(values => {
      for (const item in values) {
        // eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(item)) {
          if (values[item]) {
            formData.value[item] = values[item];
          }
        }
      }

      currentStepIndex.value++;
 

      if (!_stepperObj.value) {
        return;
      }

      
      if(currentStepIndex.value === 2){ 
        validateForm(formData.value);
      }

      _stepperObj.value.goNext();
    });
    
    
const validateForm = async (data: any) => { 
      formData.value.verifyingdata = true;
      const response: any =   await confirm_register(data);
      
      formData.value.verifyingdata = false;
    

      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
          formData.value.responsedata = response.data;
      }

    };

    const formSubmit = async () => {
       
      const response: any =   await save_register(formData.value);
       
      

      if(response.data !== undefined && response.data.result === "FAILED") {  
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });  
           if (!_stepperObj.value) {
              return;
           }
           currentStepIndex.value = 0;
          _stepperObj.value.goFirst();
          return;
      }  
      
      if(response.data !== undefined && response.data.result === "SUCCESS") {
              Swal.fire({
                text: response.data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary"
                }
              }).then(() => {
                window.location.reload();
              });
      }

      
 
    };

    resetForm({
      values: {
        ...formData.value
      }
    });

    return {
      createAccountRef,
      totalSteps,
      previousStep,
      handleStep,
      formSubmit,
      currentStepIndex,
      formData,  
      countries,
      getCities,
      cities,
      isDisabledUPID,
      isBibo
    };
  },
  methods: {
     
    getCurrentUserFirstName(){
       this.user = getCurrentUser();
     }
    
  },
  mounted() { 
    this.getCurrentUserFirstName(); 
    //this.getcountries(); 
   // this.httpGetCountries();
  },
});
